import React from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';
import styles from './PageBuilderSchedulerPreview.module.scss';
import { ReactComponent as XIcon } from 'containers/channels/collections/deleteConfirmation/icons/x.svg';
import anchorme from 'anchorme';
import { IPageBuilderSchedulerPreviewProps } from './IPageBuilderSchedulerPreviewProps';
import { isValidHexColor } from 'components/PageBuilder/PageBuilderSideBar/BlockSettings/domain';
import BlockTextContainer, { BlockSubTextContainer } from '../BlockComponents/BlockTextContainer';
import InnerHTML from 'dangerously-set-html-content';
import { CalendlyType } from 'containers/PageBuilder/SinglePageContainer/domain';

const ContentContainer: any = styled.div<{design: any}>`
    width: 100%;
    border-radius: 4px;
    position: relative;
    padding-top: ${(props: any) => 
      props.design.container_padding_top ?
      `${props.design.container_padding_top}px` :
      `0px`
    };
    padding-bottom: 0px;
    background-color: ${(props: any) => 
      props.design.container_background_color &&
      isValidHexColor(props.design.container_background_color) ?
      props.design.container_background_color :
      'transparent'
  };
`;

const IconContainer: any = styled.span<{design: any}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;

  svg {
    path {
      stroke: ${(props: any) => 
        props.design.close_icon_color &&
        isValidHexColor(props.design.close_icon_color) ?
        props.design.close_icon_color :
        '#333333'
      };
  }
`;

const ContentWrapper: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 130px);
  overflow-y: hidden;
`;

const ContentHeaderContainer: any = styled.div`
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
`;

const EmbedContentContainer: any = styled.div`
  margin-top: 10px;
  width: 100%;
  height: fit-content;
  border-radius: 0 0 .5rem .5rem;
  overflow: hidden;

  .calendly-inline-widget {
      min-width: 320px;
      height: calc(100vh - 300px);
      max-height: 600px;
      overflow: hidden;
  }
`;


const PageBuilderSchedulerPreview: React.FC<IPageBuilderSchedulerPreviewProps> = (props) => {

    const closeForm = () => {
        let pageFormsOpenStateCopy = JSON.parse(JSON.stringify(props.pageFormsOpenState));

        if(
            pageFormsOpenStateCopy &&
            pageFormsOpenStateCopy[props.pageForm.render_id]
        ) {
            pageFormsOpenStateCopy[props.pageForm.render_id] = false;

            props.setPageFormsOpenState(pageFormsOpenStateCopy);
        }
    }

    const isValidCalendlyUrl = (url: string) => {
      return url.startsWith("https://calendly.com");
    }

    const getScheduleUrl = () => {
      if(
        props.pageForm.calendly_type === CalendlyType.Event &&
        props.pageForm.event_type
      ) {
        return props.pageForm.event_type.scheduling_url;
      }

      return props.pageForm.scheduler_url;
    }
    
    const getEmbedHtml = () => {
      const schedulerUrl = props.pageForm.scheduler_url;
    
      if (
        (props.pageForm.calendly_type === CalendlyType.Link && schedulerUrl && isValidCalendlyUrl(schedulerUrl)) ||
        (
          props.pageForm.calendly_type === CalendlyType.Event &&
          props.pageForm.event_type
        )
      ) {
        return `
          <!-- Calendly inline widget begin -->
          <div id="calendly-inline-widget-${props.pageForm.render_id}" class="calendly-inline-widget" data-url="${getScheduleUrl()}?hide_event_type_details=1&hide_gdpr_banner=1"></div>
          <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
          <!-- Calendly inline widget end -->
        `;
      }
    
      return `<div></div>`;
    }
    
  return (
    <ReactModal
    isOpen={props.pageFormsOpenState[props.pageForm.render_id]}
    style={{
        content: {
          width: `${props.pageForm.design.container_width}px`,
          maxWidth: props.parentSelectorId ? `100%` : `100vw`,
          overflowY: `hidden`,
          borderRadius: ".5rem",
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          position: props.parentSelectorId ? 'absolute' : 'fixed',
          border: 0,
          padding: 0,
        },
        overlay: {
          position: props.parentSelectorId ? 'absolute' : 'fixed',
          backgroundColor: `rgba(0, 0, 0, .5)`,
          zIndex: 99999,
        }
    }}
    parentSelector={
      props.parentSelectorId ? 
      () => document.getElementById(props.parentSelectorId as string) as HTMLElement :
      undefined
    }
    portalClassName={styles.modal_portal}
    >
        <ContentContainer
        design={props.pageForm.design}
        >
          <IconContainer
          design={props.pageForm.design}
          onClick={closeForm}
          >
            <XIcon
            />
          </IconContainer>

            <ContentWrapper
            >
              <ContentHeaderContainer
              >
                <BlockTextContainer
                design={props.pageForm.design}
                pageStyles={props.pageStyles}
                textKey="heading"
                fallbackTextColor="#FFFFFF"
                dangerouslySetInnerHTML={{
                    __html: anchorme(props.pageForm.heading),
                }}
                />
    
    
                <BlockSubTextContainer
                design={props.pageForm.design}
                pageStyles={props.pageStyles}
                textKey="subtext"
                fallbackTextColor="#FFFFFF"
                dangerouslySetInnerHTML={{
                    __html: anchorme(props.pageForm.subtext),
                }}
                />
              </ContentHeaderContainer>

              <EmbedContentContainer
              >
                <InnerHTML
                html={getEmbedHtml()}
                />
              </EmbedContentContainer>
  
            </ContentWrapper>
        </ContentContainer>
    </ReactModal>
  )
}

export default PageBuilderSchedulerPreview;